import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type ContentProps = {
  children: ReactNode;
};

export const PrimaryViewContent = ({ children }: ContentProps) => {
  return <div css={contentStyles}>{children}</div>;
};

const contentStyles = css({
  flex: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
});
